<nav class="navbar-container">
    <ul class="navbar-elements">
        <li class="nav-title text-truncate">
            {{ title }}
        </li>
        <li class="search-container">
            <div class="search">
                <input class="search-input" type="text" placeholder="Buscar" autocomplete="off"
                    [formControl]="searchControl" [disabled]="isLoading" (keyup.enter)="search()" />
                <button type="button" class="search-icon-btn" [disabled]="isLoading" (click)="search()"
                    aria-label="Buscar">
                    <img class="search-icon" src="assets/icons/search.svg" alt="Buscar" />
                </button>
            </div>
        </li>
        <li class="support" *ngIf="!isMobile">
            <a [routerLink]="disabledLink">
                <img *ngIf="!disabledLink" class="support-icon" src="assets/icons/question.png" alt="" />
                <button type="button" class="create-btn" disabled>Soporte</button>

            </a>
        </li>
        <li class="user-profile">
            <div class="dropdown">
                <button class="user-btn" type="button" id="userDropdownbtn" data-toggle="dropdown" aria-haspopup="true"
                    data-bs-toggle="dropdown" aria-expanded="false">
                    <img class="user" src="assets/images/user.png" alt="assets/images/user.png" />
                    <fa-icon class="arrow-icon" [icon]="faCaretDown"></fa-icon>
                </button>
                <div class="user-dropdown dropdown-menu" aria-labelledby="userDropdownbtn">
                    <div class="items-container">
                        <a class="dropdown-item" routerLink="/user/profile">Editar Perfil</a>
                        <a style="color: #ccc" class="dropdown-item" [routerLink]="disabledLink">Solicitud de
                            permiso</a>
                        <a style="color: #ccc" class="dropdown-item" [routerLink]="disabledLink">Accesos</a>
                        <a class="dropdown-item disabled" [routerLink]="disabledLink" *ngIf="isMobile">Soporte</a>
                        <a class="dropdown-item" (click)="logout()">Cerrar sesión</a>
                    </div>
                </div>
            </div>
        </li>
        <ngx-ui-loader loaderId="header" [hasProgressBar]="false"></ngx-ui-loader>
    </ul>
</nav>